import { type ContentDataItem } from "~/utils/models";
import { resolveApiUrl } from "../../../utils/url/urlResolver";

export interface ContentSearchResultsDTO {
  contentData: ContentDataItem[];
  pagination: {
    pageSize: number;
    currentPage: number;
    sort: string;
    numberOfPages: number;
    totalNumberOfResults: number;
  };
}

const baseUrl = resolveApiUrl("/search/searchpage/contentsearch");

export function fetchContentSearchResults(query: string, page: number = 0): Promise<ContentSearchResultsDTO | false> {
  const params = new URLSearchParams();
  params.set("text", query);
  params.set("page", page.toString());

  const url = `${baseUrl}?${params.toString()}`;

  return fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  }).then((response) => {
    if (response.redirected) {
      window.location.reload();
    } else if (response.ok) {
      return response.json();
    }
    return false;
  });
}
